export async function checkRecordingExists(
  videoId: string | { IdValue: string },
  recordingsRootUrl: string,
): Promise<boolean> {
  if (!videoId) {
    return false;
  }

  videoId = typeof videoId === 'string' ? videoId : videoId.IdValue;
  const url = `${recordingsRootUrl}/${videoId}/playlist.m3u8`;

  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch {
    return false;
  }
}
